import React from "react";
import {RouteComponentProps} from "react-router-dom";
import TopMenu from "../components/TopMenu/TopMenu";
import AppFooter from "../components/AppFooter/AppFooter";
import {Layout, Modal} from "antd";
import {Content} from "antd/es/layout/layout";
import SubscriptionContainer from "../components/Subscription/SubscriptionContainer";
import {TrackClickUpgrade} from "../utils/Amplitude";
import {isPremiumSubscriptionDisabled} from "../utils/User";

export default class Subscribe extends React.Component<RouteComponentProps> {
    public render() {
        if (isPremiumSubscriptionDisabled()) {
            return (
                <Layout>
                    <TopMenu/>
                    <Content className="site-layout-background" style={{ padding: 24 }}>
                        <p>Subscriptions are temporarily unavailable.</p>
                    </Content>
                    <AppFooter/>
                </Layout>
            )
        }
        return(
            <Layout>
                <TopMenu/>
                <Content className="site-layout-background">
                    <SubscriptionContainer/>
                </Content>
                <AppFooter/>
            </Layout>
        )
    }
}

export const UpgradeButtonAction = (source: string) => {
    TrackClickUpgrade(source)
    if (isPremiumSubscriptionDisabled()) {
        Modal.info({
            title: 'Subscriptions paused',
            content: 'Paid subscriptions are temporarily unavailable. You already have full access while this is in effect.',
        })
        return
    }
    window.location.href = '/subscribe'
}